import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { ShopMaxPerDay } from '../../../shared/models/slot-management.model';
import { Observable, Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import { SlotState } from '../../../store/slot/slot.reducer';
import * as fromActions from '../../../store/slot/slot.actions';
import * as fromSelector from '../../../store/slot/slot.selectors';
import { UntypedFormGroup, UntypedFormBuilder, UntypedFormArray, UntypedFormControl } from '@angular/forms';
import { take } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { titleCase } from '../../../shared/services/util.service';
import _ from 'lodash'

@Component({
  selector: 'app-shop-max',
  templateUrl: './shop-max.component.html',
  styleUrls: ['./shop-max.component.scss']
})
export class ShopMaxComponent implements OnInit, OnDestroy {

  totalCapacity: number = 0;
  totalHours: number = 0;
  subscriptions: Subscription[] = [];
  shopMaxTotal$: Observable<ShopMaxPerDay[]>;
  shopMaxForm: UntypedFormGroup;
  @Input() saveClicked:boolean
  @Input() cancleClicked:boolean
  @Input() viewMode:String
  @Output() formEdited:EventEmitter<boolean> = new EventEmitter();
  @Output() cancleClick:EventEmitter<boolean> = new EventEmitter();
  @Output() saveClick:EventEmitter<boolean>=new EventEmitter();
  isFormEdited:boolean=false;
  lastValue:any
  //Team slot save button clicked for the form
  isSaveClicked:boolean=false

  constructor(private readonly slotState: Store<SlotState>,
    private readonly formBuilder: UntypedFormBuilder,
    private readonly translate: TranslateService) {
    this.shopMaxForm = this.formBuilder.group({
      shopMaxDetails: this.formBuilder.array([])
    });
  }

  ngOnInit() {
    
    this.slotState.dispatch(new fromActions.LoadShopMaxTotal());

    this.shopMaxTotal$ = this.slotState.select(fromSelector.selectShopMaxTotal);

    this.subscriptions.push(
      this.shopMaxTotal$.subscribe(total => {
        this.setShopMaxDetails(this.shopMaxDetails, total);
        this.calculateTotals();
      })
    );
    this.subscriptions.push(this.shopMaxForm.valueChanges.subscribe(value => {
         this.calculateTotals();
         this.formEdited.emit(this.shopMaxForm.dirty)
         //team slot
         //team screen buttons
         if(this.viewMode === 'Team' && this.shopMaxForm.dirty)
         {
           this.isSaveClicked=true
         }
       })
    );
   }

   ngOnChanges()
  {
    if(this.saveClicked && this.shopMaxForm.dirty)
    {
      this.onSave();
    }
    if(this.cancleClicked && this.shopMaxForm.dirty)
    {
      this.onCancel();
    } 
  }

   calculateTotals(){
    this.totalCapacity = 0;
    this.totalHours = 0;
    this.shopMaxDetails.value.forEach(a => {
      this.totalCapacity += a.slotCapacity;
      this.totalHours += a.flatRateHours;
    });
   }

  get shopMaxDetails() {
    return this.shopMaxForm.controls.shopMaxDetails as UntypedFormArray;
  }

  setShopMaxDetails(formArray: UntypedFormArray, data: ShopMaxPerDay[]) {
    if (data && data.length) {
      formArray.clear();
      data.forEach((total: ShopMaxPerDay) => {
        formArray.push(new UntypedFormGroup({
          dayOfWeek: new UntypedFormControl(total.dayOfWeek),
          hoursOfOperation: new UntypedFormControl(total.hoursOfOperation),
          slotCapacity: new UntypedFormControl(total.slotCapacity),
          flatRateHours: new UntypedFormControl(total.flatRateHours)
        }));
      });
    }
  }

  getWeekDays(day)
  {
    return this.translate.instant(`common.${titleCase(day)}`);
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  onSave(){
    this.slotState.dispatch(new fromActions.UpdateShopMaxTotal({shopMaxTotal : this.shopMaxDetails.value}))
    if(this.viewMode === 'Team')
    {
      this.isSaveClicked=false;
      this.shopMaxForm.markAsPristine();
    }else
    {
      this.saveClick.emit(false);
      this.formEdited.emit(false);
      this.shopMaxForm.markAsPristine();
    }
  }

  onCancel(){
    this.subscriptions.push(this.shopMaxTotal$.pipe(take(1)).subscribe(total => {
      this.setShopMaxDetails(this.shopMaxDetails, total);
    }));
    if(this.viewMode === 'Team')
    {
      this.isSaveClicked=false;
    }else
    {
      this.cancleClick.emit(false);
      this.formEdited.emit(false);
    }
    this.shopMaxForm.markAsPristine();
  }
}
